<template>

  <span :class="`wistia_embed wistia_async_${asset} popover=true popoverAnimateThumbnail=true popoverContent=html`">
    <slot/>
  </span>
</template>
<style>
.wistia_embed div {
  display: inline;
}
</style>
<script>
let downloaded = false;
export default {
  props: ['asset', 'autoplay'],
  created() {
    if (this.autoplay) {
      //note: popoverShowOnLoad didn't work
      window._wq = window._wq || [];
      window._wq.push({
        id: this.asset,
        onReady(video) {
          video.popover.show();
          video.play();
        }
      });
    }
    if (!downloaded) {
      this.addScript(`//fast.wistia.com/embed/medias/${this.asset}.jsonp`);
      this.addScript("//fast.wistia.com/assets/external/E-v1.js");
      downloaded = true;
    }
  },
  methods: {
    addScript(src, onload) {
      let node = document.createElement('script');
      node.setAttribute('src', src);
      node.setAttribute('async', '');
      if (onload) node.onload = onload;
      document.head.appendChild(node);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/WistiaMovie.vue